import { render } from "./CustomerOtpVerification.vue?vue&type=template&id=3ed7ae82&scoped=true"
import script from "./CustomerOtpVerification.vue?vue&type=script&lang=js"
export * from "./CustomerOtpVerification.vue?vue&type=script&lang=js"

import "./CustomerOtpVerification.vue?vue&type=style&index=0&id=3ed7ae82&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ed7ae82"]])

export default __exports__